import { i18n, t } from "@/i18n";

export function resizeAllGridItems() {
    const e = document.querySelectorAll("[data-el-item]");
    if (e.length) for (let t = 0; t < e.length; t++) resizeGridItem(e[t]);
}

function resizeGridItem(e) {
    const t = e.closest("[data-el-grid]"),
        i = t ? parseInt(window.getComputedStyle(t).getPropertyValue("grid-auto-rows")) : null,
        d = t ? parseInt(window.getComputedStyle(t).getPropertyValue("grid-row-gap")) : null,
        o = t
            ? Math.ceil(
                  (e.querySelector("[data-el-content]").getBoundingClientRect().height + d) /
                      (i + d)
              )
            : null;
    e.style.gridRowEnd = "span " + o;
}

export function setFontFamily(newFont, currentFont) {
    if (newFont === currentFont) {
        return currentFont;
    }

    const fontNameNoSpaces = (newFont || "").replaceAll(" ", "+");

    if (document.querySelector(`[data-font="${fontNameNoSpaces}"]`)) {
        // skip if font already loaded...
        return currentFont;
    }

    const link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");
    link.setAttribute("data-font", fontNameNoSpaces);
    link.setAttribute(
        "href",
        `https://fonts.googleapis.com/css?family=${fontNameNoSpaces}:300,400,500,600,700,800`
    );
    document.head.appendChild(link);
    return newFont;
}

export function updateIframeHeight(name, uuid) {
    if (document.body) {
        const e = document.body.scrollHeight + "px";
        const postData = { frameHeight: e };
        postData[`${name}Uuid`] = uuid;
        window.parent.postMessage(postData, "*");
    }
}

export function showAlertOnParent(alert) {
    window.parent.postMessage({ alert }, "*");
}

export function handleLinkClick(url, preview, target = "_blank") {
    if (preview) {
        const alert = {
            title: t("r_shared.preview.title"),
            message: t("r_shared.preview.links"),
            type: "warning",
        };
        showAlertOnParent(alert);
        return;
    }
    window.open(url, target);
}

export function handleActionClick() {
    const alert = {
        title: t("r_shared.preview.title"),
        message: t("r_shared.preview.actions"),
        type: "warning",
    };
    showAlertOnParent(alert);
}

export function updateIframeView(name, uuid, view) {
    const postData = { setView: view };
    postData[`${name}Uuid`] = uuid;
    window.parent.postMessage(postData, "*");
}

export function searchQuery() {
    class FaqSearch {
        constructor(elem) {
            this.searchInput = elem;
            this.container = this.searchInput.closest(".faq");
            this.questions = this.container
                ? this.container.querySelectorAll("[data-js-faq-question]")
                : null;
            this.sections = this.container
                ? this.container.querySelectorAll("[data-js-faq-section]")
                : null;
            this.textSelectors = "h1, h2, h3, h4, h5, h6, p, span";
            this.assignEvents();
        }

        assignEvents() {
            if (this.questions) {
                this.searchInput.addEventListener("keyup", this.searchResults.bind(this));
                this.searchInput.addEventListener("keypress", function (e) {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                });
            }
        }

        searchResults() {
            this.queryText = this.searchInput.value.toLowerCase();

            if (this.queryText.length > 0) {
                this.questions.forEach((question) => {
                    const fullText = question.textContent;
                    if (fullText.toLowerCase().indexOf(this.queryText) > -1) {
                        delete question.dataset.searchHide;
                        if (!question.dataset.filterHide)
                            question.style.display = question.dataset.jsFaqQuestion;
                        this.showResult(question);
                    } else {
                        question.style.display = "none";
                        question.dataset.searchHide = true;
                    }
                });
                this.sections.forEach((section) => {
                    section.style.display = "none";
                });
            } else {
                this.clearSearch();
            }
        }

        showResult(question) {
            const texts = question.querySelectorAll(this.textSelectors);
            texts.forEach((text) => {
                text.innerHTML = this.highlightText(text.innerText);
            });
        }

        hideResult(question) {
            const texts = question.querySelectorAll(this.textSelectors);
            texts.forEach((text) => {
                text.innerHTML = text.innerText;
            });
        }

        clearSearch() {
            this.questions.forEach((question) => {
                if (question.dataset.searchHide) {
                    delete question.dataset.searchHide;
                    question.style.display = question.dataset.jsFaqQuestion;
                }
                this.hideResult(question);
            });
            this.sections.forEach((section) => {
                section.style.display = "block";
            });
        }

        highlightText(text) {
            const myReg = new RegExp("(" + this.queryText + ")", "gi");
            return text.replace(myReg, "<span style='background: yellow'>$1</span>");
        }
    }
    const faqSearches = document.querySelectorAll("[data-js-faq-search]");
    if (faqSearches) {
        faqSearches.forEach((search) => {
            new FaqSearch(search);
        });
    }
}

export function openGallery() {
    const e = document.querySelectorAll("[data-el-img]");
    e.forEach((e) => {
        e.addEventListener("click", showImage);
    });
}

export function showImage(e) {
    const imageSrc = e.target.closest("[data-el-img]").dataset.elImg;
    const modal = document.createElement("div");
    const topPosition = Math.max(e.clientY - 200, 0);
    const isVideo =
        imageSrc.indexOf(".webm") !== -1 ||
        imageSrc.indexOf(".mp4") !== -1 ||
        imageSrc.indexOf(".mov") !== -1 ||
        imageSrc.indexOf(".m4v") !== -1;
    modal.classList.add("modal", "hide");
    modal.style.top = topPosition + "px";

    modal.innerHTML = `<div class='modal-box'><div class='modal-in'><span data-el-close='' type='button' class='close'></span> ${
        isVideo ? '<video class="w-full m-auto"></video>' : '<img class="m-auto"/>'
    } </div></div>`;

    isVideo
        ? (modal.querySelector("video").src = imageSrc)
        : (modal.querySelector("img").src = imageSrc);

    document.body.appendChild(modal);

    setTimeout(() => {
        modal.classList.remove("hide"), isVideo && modal.querySelector("video").play();
    }, 100);

    modal.addEventListener("click", () => {
        modal.classList.add("hide"),
            setTimeout(() => {
                document.body.removeChild(modal);
            }, 300);
    });
}

export function sendWebhook(data, url) {
    if (!url) return;
    const dataToSent = data;
    dataToSent.location = window.location.href;

    const xhttp = new XMLHttpRequest();
    xhttp.open("POST", url, true);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.send(JSON.stringify(dataToSent));
}

export function goToField(name, view, field = "", open = "", id = "") {
    if (open) {
        window.parent.postMessage({ setRoute: { name, query: { view, field, open, id } } }, "*");
    } else {
        if (!field) {
            window.parent.postMessage({ setRoute: { name, query: { view } } }, "*");
        } else {
            window.parent.postMessage({ setRoute: { name, query: { view, field } } }, "*");
        }
    }
}

export function setLanguage(lang) {
    i18n.global.locale.value = lang;
}
